import { PropsWithChildren } from 'react'
import { ArticleType } from 'helpers/strapi/types'
import { Article } from 'routes/components/Article'
import { MarkdownArticle, MarkdownArticleToc } from 'routes/components/Markdown'
import { InnerPageLayout } from 'routes/layouts'
import { JsonViewer } from 'routes/components/JsonViewer'
import { ArticleSeoMetatags } from 'routes/components/Article/ArticleSeoMetatags'
import { ArticleShare } from 'routes/components/Article/ArticleShare'
import { ArticleHeader } from 'routes/components/Article/ArticleHeader'

export function SimpleStrapiPage({
  article,
  isDraft,
  children,
}: PropsWithChildren<{
  article: ArticleType
  isDraft?: boolean
}>) {
  if (!article) return null
  const { title, content } = article
  return (
    <InnerPageLayout>
      <ArticleSeoMetatags article={article} isDraft={isDraft} />
      <Article>
        <Article.Content>
          <ArticleHeader>{title}</ArticleHeader>
          <Article.StyledTypography>
            <MarkdownArticle>{content}</MarkdownArticle>
          </Article.StyledTypography>
          <ArticleShare title={title} />
          <JsonViewer json={article} className={'mt-8'} />
        </Article.Content>
        <Article.Sidebar sticky>
          <MarkdownArticleToc>{content}</MarkdownArticleToc>
          {children}
        </Article.Sidebar>
      </Article>
    </InnerPageLayout>
  )
}
